export const Svg_101 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M14.583 58.333V35h-8.75L35 8.75 64.166 35h-8.75v23.333H14.584Zm5.833-5.833h29.167V29.75L35 16.625 20.416 29.75V52.5ZM35 46.667c1.604 0 2.977-.572 4.12-1.714 1.142-1.142 1.713-2.516 1.713-4.12 0-1.312-.364-2.71-1.094-4.192-.729-1.483-2.309-3.974-4.74-7.474-2.43 3.5-4.01 5.991-4.739 7.474-.729 1.482-1.094 2.88-1.094 4.192 0 1.605.572 2.978 1.714 4.12s2.516 1.714 4.12 1.714Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={41.004}
        y1={16.188}
        y2={57.47}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)